import { Button, Stack } from '@mui/material';

import { getGeneralFeedbackUrl } from 'constants/feedback.constants';
import { Routes } from 'constants/routes.constants';
import { useEmbedded } from 'hooks/useEmbedded';
import { useLocale } from 'hooks/useLocale';
import { useModalControl } from 'hooks/useModalControl';
import { useConsent } from 'services/consent-manager';

import SettingsLink from 'components/@account/SettingsLink';
import ContactDialog from 'components/@common/ContactDialog';
import LinkUnstyled from 'components/@common/LinkUnstyled';

const SettingLinksList = () => {
  const { locale: activeLocale } = useLocale();
  const { isEmbedded } = useEmbedded();
  const { openPreferences } = useConsent();
  const {
    open: openContact,
    onClose: onCloseContact,
    onOpen: onOpenContact,
  } = useModalControl();

  return (
    <Stack
      sx={{
        gap: 1,
        mb: 4,
      }}
    >
      <SettingsLink
        iconName="QuestionCircle"
        intlId="account.settings.help"
        component={Button}
        onClick={onOpenContact}
      />
      <SettingsLink
        iconName="Bulb"
        intlId="account.settings.feedback"
        component={LinkUnstyled}
        href={getGeneralFeedbackUrl(activeLocale)}
        target="_blank"
      />
      <SettingsLink
        iconName="List"
        intlId="account.settings.terms.of.use"
        component={LinkUnstyled}
        href={Routes.TermsOfService}
      />
      <SettingsLink
        iconName="Shield"
        intlId="account.settings.privacy"
        component={LinkUnstyled}
        href={Routes.PrivacyPolicy}
      />
      {!isEmbedded && (
        <SettingsLink
          iconName="Edit"
          intlId="account.settings.cookie.preferences"
          component={Button}
          onClick={openPreferences}
        />
      )}
      <ContactDialog open={openContact} onClose={onCloseContact} />
    </Stack>
  );
};

export default SettingLinksList;
